Pollfish.deprecated = (function deprecated() {
  return {
    sendInstalledApps() {
      // send device data only the first time
      let shouldSendInstalledApps = false; //eslint-disable-line
      const currentPage = $('body').attr('data-page');
      // only send installed apps in the pages where the AndroidIndicator is shown.
      // Currently it is shown only on homescreen pages
      if (currentPage && currentPage.match(/(homescreen-|unlock-screen)/)) {
        shouldSendInstalledApps = true;
      }

      // Pollfish.mobile.interface.sentDataOfUserConsentToServer('/v2/device/info',
      // shouldSendInstalledApps);
    },
  };
})();

export default Pollfish.deprecated;
